import { useEffect, useState } from "react";
import { buildOptionsFilterStr, reformatAnalysisData } from "../../../util/helperFunctions";
import { changeZeroToNull, featureConversion, unitConversion } from "../util/analysisUtils";
import moment from "moment";
import { toast } from "react-toastify";
import { fetchExpressions } from "../../../api/sensorApi";

function useFetchSensorData({
    sensorIDs, start, end, interval, passedFeature, context
}) {
    const [sensorData, setSensorData] = useState();
    const [sensorDataLoading, setSensorDataLoading] = useState(false);

    useEffect(() => {
        console.log(sensorIDs, passedFeature, context.units)
        if (sensorIDs != null && sensorIDs.length > 0 && moment(start).toDate().toString() !== "Invalid Date" && moment(end).toDate().toString() !== "Invalid Date") {
            setSensorDataLoading(true);
            fetchExpressions( "SensorExpression", {
                    subject_filter: `sensor.id IN (${sensorIDs.map(item => `'${item}'`).join(", ")})`,
                    expressions: passedFeature.map(ele => ele.id),
                    start: moment(start).format("YYYY-MM-DD"),
                    end: moment(end).format("YYYY-MM-DD"),
                    interval: interval.value,
                    units: passedFeature.map(ele => unitConversion(ele.id, context.units))
            }).then((sensorData) => {
                sensorData = reformatAnalysisData(sensorData);
                sensorData = changeZeroToNull(sensorData);
                setSensorData(sensorData);
                setSensorDataLoading(false);
            }).catch(err => {
                console.log(err);
                setSensorDataLoading(false);
                toast.error("error fetching sensor data")
            });
        }
        else setSensorData();
    }, [sensorIDs, start, end, interval.value, passedFeature, context.units]);

    return { sensorData, sensorDataLoading }
}

export default useFetchSensorData;